import { identify as amplitudeIdentify } from "@opensea/analytics"
import { type Address, normalizeAddress } from "@opensea/utils"
import { setUser } from "@sentry/nextjs"
import { setUser as setDatadogUser } from "@/lib/integrations/datadog"

export function identify(address: Address | undefined) {
  const normalizedAddress = address ? normalizeAddress(address) : undefined
  void amplitudeIdentify(normalizedAddress)
  void setDatadogUser(normalizedAddress)
  setUser(normalizedAddress ? { id: normalizedAddress } : null)
}
